import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import * as qs from "qs";
import axiosApi from "../../utils/httpClient";
const name = "sentToMentor";
const initialState = {
  sentToMentor: [],
  loading: false,
  error: null,
};

export const sentToMentorAPI = createAsyncThunk(
  "sentToMentor",
  async ({ search, skip, limit, type }) => {
    var formData = {};

    const data = await axiosApi.get(
      `${
        process.env.REACT_APP_BASE_URL
      }application/mentor/applied/?skip=${skip}&limit=${limit}${
        search != "" ? `&search=${search}` : ""
      }`,
      {
        params: formData,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      }
    );
    return data.data;
  }
);

const sentToMentorSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(sentToMentorAPI.pending, (state) => {
      state.sentToMentor = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(sentToMentorAPI.fulfilled, (state, action) => {
      state.sentToMentor = action.payload.data;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(sentToMentorAPI.rejected, (state, action) => {
      state.sentToMentor = [];
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default sentToMentorSlice.reducer;
